module.exports = __webpack_public_path__ + "img/embersadrift-screenshot-08.445bc087.jpg";